var _rect, _mask, _path, _mask2, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLibrary(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 7.28674,
    height: 22.9395,
    rx: 1.5,
    stroke: "currentColor"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_211_3770",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.36597 5.68359C7.36597 4.57902 8.2614 3.68359 9.36597 3.68359H11.8112C12.9158 3.68359 13.8112 4.57902 13.8112 5.68359V21.9401C13.8112 23.0446 12.9158 23.9401 11.8112 23.9401H9.36597C8.2614 23.9401 7.36597 23.0446 7.36597 21.9401V5.68359Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.36597 5.68359C7.36597 4.57902 8.2614 3.68359 9.36597 3.68359H11.8112C12.9158 3.68359 13.8112 4.57902 13.8112 5.68359V21.9401C13.8112 23.0446 12.9158 23.9401 11.8112 23.9401H9.36597C8.2614 23.9401 7.36597 23.0446 7.36597 21.9401V5.68359Z",
    stroke: "currentColor",
    strokeWidth: 2,
    mask: "url(#path-2-inside-1_211_3770)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-2_211_3770",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8522 8.86853C18.5502 8.09713 17.68 7.71665 16.9086 8.0187L15.4152 8.60343C14.6438 8.90548 14.2633 9.77568 14.5654 10.5471L18.8839 21.5761C19.186 22.3475 20.0562 22.728 20.8276 22.426L22.3209 21.8412C23.0923 21.5392 23.4728 20.669 23.1708 19.8976L18.8522 8.86853ZM14.2872 8.24801C13.5158 8.55006 13.1354 9.42027 13.4374 10.1917L18.2972 22.603C18.5992 23.3744 19.4694 23.7548 20.2408 23.4528L23.4489 22.1966C24.2203 21.8946 24.6008 21.0244 24.2987 20.253L19.439 7.8417C19.1369 7.0703 18.2667 6.68981 17.4953 6.99186L14.2872 8.24801Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8522 8.86853C18.5502 8.09713 17.68 7.71665 16.9086 8.0187L15.4152 8.60343C14.6438 8.90548 14.2633 9.77568 14.5654 10.5471L18.8839 21.5761C19.186 22.3475 20.0562 22.728 20.8276 22.426L22.3209 21.8412C23.0923 21.5392 23.4728 20.669 23.1708 19.8976L18.8522 8.86853ZM14.2872 8.24801C13.5158 8.55006 13.1354 9.42027 13.4374 10.1917L18.2972 22.603C18.5992 23.3744 19.4694 23.7548 20.2408 23.4528L23.4489 22.1966C24.2203 21.8946 24.6008 21.0244 24.2987 20.253L19.439 7.8417C19.1369 7.0703 18.2667 6.68981 17.4953 6.99186L14.2872 8.24801Z",
    stroke: "currentColor",
    strokeWidth: 2,
    mask: "url(#path-3-inside-2_211_3770)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibrary);
export default __webpack_public_path__ + "static/media/library.c2a327a31f58d5f16c08451fd0ae6564.svg";
export { ForwardRef as ReactComponent };